import { NAME } from './constants';

export const BULK_UPDATE_ITEMS = `${NAME}/BULK_UPDATE_ITEMS`;
export const BULK_UPDATE_ITEMS_FAILURE = `${NAME}/BULK_UPDATE_ITEMS_FAILURE`;
export const BULK_UPDATE_ITEMS_SUCCESS = `${NAME}/BULK_UPDATE_ITEMS_SUCCESS`;

export const FETCH_USERS = `${NAME}/FETCH_USERS`;
export const FETCH_USERS_FAILURE = `${NAME}/FETCH_USERS_FAILURE`;
export const FETCH_USERS_SUCCESS = `${NAME}/FETCH_USERS_SUCCESS`;

export const FETCH_CONTACTS = `${NAME}/FETCH_CONTACTS`;
export const FETCH_CONTACTS_FAILURE = `${NAME}/FETCH_CONTACTS_FAILURE`;
export const FETCH_CONTACTS_SUCCESS = `${NAME}/FETCH_CONTACTS_SUCCESS`;

export const FETCH_FILTER_CONTACTS = `${NAME}/FETCH_FILTER_CONTACTS`;
export const FETCH_FILTER_CONTACTS_FAILURE = `${NAME}/FETCH_FILTER_CONTACTS_FAILURE`;
export const FETCH_FILTER_CONTACTS_SUCCESS = `${NAME}/FETCH_FILTER_CONTACTS_SUCCESS`;

export const INITIALIZE = `${NAME}/INITIALIZE`;
export const INITIALIZE_SUCCESS = `${NAME}/INITIALIZE_SUCCESS`;
export const INITIALIZE_FAILURE = `${NAME}/INITIALIZE_FAILURE`;

export const INITIALIZE_REASIGN_FORM = `${NAME}/INITIALIZE_REASIGN_FORM`;

export const OPEN_MODAL = `${NAME}/OPEN_MODAL`;

export const RESET = `${NAME}/RESET`;

export const RESET_REASIGN_FORM = `${NAME}/RESET_REASIGN_FORM`;

export const SAVE_CONTACT = `${NAME}/SAVE_CONTACT`;
export const SAVE_CONTACT_FAILURE = `${NAME}/SAVE_CONTACT_FAILURE`;
export const SAVE_CONTACT_SUCCESS = `${NAME}/SAVE_CONTACT_SUCCESS`;

export const SET_IS_DOWNLOADING = `${NAME}/SET_IS_DOWNLOADING`;

export const SET_IS_OPEN_REASIGN_MODAL = `${NAME}/SET_IS_OPEN_REASIGN_MODAL`;

export const SET_IS_UPLOADING = `${NAME}/SET_IS_UPLOADING`;

export const SHOW_EMPTY_STATE = `${NAME}/SHOW_EMPTY_STATE`;

export const UPDATE_ITEMS_SUCCESS = `${NAME}/UPDATE_ITEMS_SUCCESS`;
